import React from "react";
import { Box } from 'apps/sigma2-ui/src/components/ui/Box';
import { S2Typography } from 'apps/sigma2-ui/src/components/ui/Typography';

export const EnabledDisabledBanner = ({ isEnabled }: { isEnabled: boolean }) => {
    return (
      <Box>
        {isEnabled ? (
          <Box bg={'green-100'} p={'xs'} rounded={'lg'}>
            <S2Typography
              variant={'body-7'}
              translatedContent={'Enabled'}
              textColorVariant={'green-800'}
            />
          </Box>
        ) : (
          <Box bg={'red-100'} p={'xs'} rounded={'lg'}>
            <S2Typography
              variant={'body-7'}
              translatedContent={'Disabled'}
              textColorVariant={'red-800'}
            />
          </Box>
        )}
      </Box>
    );
  };
